import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messagesDe from '@src/lang/de';
import messagesEn from '@src/lang/en';
// import axios from 'axios';

const messages = Object.assign({}, messagesEn, messagesDe);

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages,
});
